// extracted by mini-css-extract-plugin
module.exports = {"container":"STMf02bZhdT1WqEfHjgqg","cancelBtn":"_3k-_eJ_wv7xsrCH1usV-m3","icon":"_2h74rPM2cs8FvnYlJO-AZQ","saveBtn":"_1VanLxcTWRYZ6l_P1HU7Cs"};